import React from 'react';

export default class Seo extends React.Component {

    render(){

        return(
            <>


                 {/* Portfolio Section */}
                 <section className="page-section text-white mb-0 seo" id="seo">
                    <div className="container">

                    {/* About Section Heading */}
                    <h2 className="page-section-heading text-center text-uppercase text-white">Seo e Responsividade</h2>

                    {/* Icon Divider */}
                    <div className="divider-custom divider-light">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon">
                        <i className="fa fa-star"></i>
                        </div>
                        <div className="divider-custom-line"></div>
                    </div>

                        <div className="row text-center">
                        <h4>Nossas lojas são desenvolvidas com tecnologia de ponta, através das responsividade (termo técnico) nossas lojas se adaptam a diferentes tipos de resoluções. Tanto para tables como celulares. Além disso, contamos com um excelente sistema de Seo orgânico, o que permite ser encontrado pelos motores de busca com mais facilidade.</h4> 
                        </div>

                    </div>
                </section>


            </>
       );
    }
}